module.exports = __webpack_public_path__ + "img/school_qzyc1.c376102f.png";